import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";
import useScrollToTop from "./hooks/useScrollToTop";

function App() {
  return (
    <BrowserRouter>

      {/* 👇 MOVE HOOK HERE */}
      <ScrollHandler />

      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </div>

    </BrowserRouter>
  );
}

export default App;


// 👇 Small wrapper component INSIDE router
function ScrollHandler() {
  useScrollToTop();
  return null;
}
